import { mockAwareFetch } from "@/portals/physician/api/transport";
import type { AppNotification } from "@/stores/notificationsStore";

interface NotificationListResponse {
  data: AppNotification[];
  unreadCount: number;
}

// Same account regardless of portal (see CaregiverProtectedLayout) — always
// hits the patient-backed endpoint, matching every other cross-portal call
// in this app (see caregiverApi.ts's own header comment).
export async function listNotificationsApi() {
  const { data, error } = await mockAwareFetch<NotificationListResponse>("/api/notifications", {
    method: "GET",
    portal: "patient",
  });
  return { data, error: error?.message ?? null };
}

export async function markNotificationReadApi(id: string) {
  const { data, error } = await mockAwareFetch<{ message?: string }>(`/api/notifications/${id}/read`, {
    method: "POST",
    portal: "patient",
  });
  return { data, error: error?.message ?? null };
}

export async function markAllNotificationsReadApi() {
  const { data, error } = await mockAwareFetch<{ message?: string }>("/api/notifications/read-all", {
    method: "POST",
    portal: "patient",
  });
  return { data, error: error?.message ?? null };
}
